import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";
import { SHOP } from "@/data/site";

const FAQS = [
    {
        q: "Yuhuku Kopi buka jam berapa?",
        a: "Setiap hari, pukul 11.00 sampai 21.00 WIB — termasuk akhir pekan.",
    },
    {
        q: "Di mana lokasinya?",
        a: `Perum Raffles Residence Blok C3-04, Bandar Lampung. Petunjuk arah lengkap ada di halaman Kontak, atau cari "Yuhuku Kopi" di Google Maps.`,
    },
    {
        q: "Bisa pesan tanpa datang ke cafe?",
        a: "Bisa — tersedia di GoFood untuk pengantaran, atau DM Instagram @yuhuku.kopi untuk pesanan tertentu seperti bottled dan seliter.",
    },
    {
        q: "Seliter itu isinya apa aja?",
        a: "Versi botol 1 liter untuk 6–7 porsi: Signature dan Arena 75K, Chocolate dan RedVelvet 115K, Matcha 125K. Simpan dingin, seger disajikan.",
    },
    {
        q: "Menu paling direkomendasikan buat pertama kali?",
        a: "Signature (15K) — espresso, creamer, coconut & palm sugar. Kalau nggak ngopi, Matcha Latte (23K) yang paling sering dipesan.",
    },
    {
        q: "Ada menu non-kopi atau camilan?",
        a: "Ada — Matcha Latte, Matcha Cloud, Matcha Oat, Red Velvet, Chocolate, plus camilan seperti French Fries, Indomie Telur, Rujak Cireng, sampai Chicken Burger. Lengkapnya di halaman Menu.",
    },
    {
        q: "Kalau mau pesan banyak untuk acara?",
        a: `Bisa banget. Kirim pesan lewat halaman Kontak atau DM Instagram ${SHOP.instagramHandle} — sebutkan tanggal, jumlah, dan pesanannya, nanti kami balas soal ketersediaan.`,
    },
];

export default function Faq() {
    return (
        <div className="pt-24 lg:pt-32" data-testid="faq-page">
            <header className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <Reveal>
                    <span className="eyebrow">Sering ditanyain ini</span>
                </Reveal>
                <Reveal delay={0.08}>
                    <h1 className="mt-4 font-display text-5xl font-extrabold tracking-tighter text-ink sm:text-6xl lg:text-7xl">
                        FAQ.
                    </h1>
                </Reveal>
                <Reveal delay={0.16}>
                    <p className="mt-5 max-w-xl leading-relaxed text-ink-muted">
                        Jawaban singkat untuk pertanyaan yang paling sering
                        masuk. Belum terjawab? Kirim pesan di halaman Kontak.
                    </p>
                </Reveal>
            </header>

            <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
                <Reveal delay={0.1}>
                    <Accordion
                        type="single"
                        collapsible
                        className="rounded-3xl border border-ink/5 bg-white px-2 shadow-soft sm:px-4"
                    >
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={f.q}
                                value={`faq-${i}`}
                                className="border-b border-ink/5 last:border-b-0"
                            >
                                <AccordionTrigger
                                    data-testid={`faq-item-${i + 1}`}
                                    className="px-4 py-5 text-left font-semibold text-ink hover:no-underline hover:text-accent sm:px-6"
                                >
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="px-4 pb-6 leading-relaxed text-ink-muted sm:px-6">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>

                <Reveal delay={0.15}>
                    <p className="mt-10 text-center text-sm text-ink-muted">
                        Masih ada yang mau ditanyakan?{" "}
                        <a
                            href={SHOP.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="faq-link-instagram"
                            className="font-semibold text-accent hover:underline"
                        >
                            DM kami di Instagram
                        </a>{" "}
                        — dibalas secepat kopinya diseduh.
                    </p>
                </Reveal>
            </div>
        </div>
    );
}